import { Component, OnInit } from '@angular/core';
import { BarcodeScannerService } from '../../../services/barcode-scanner.service';
import { LotItemProxyService } from '../../../proxies/inventory/lot-item.proxy.service';
import { LotItem } from '../../../models/inventory/lot-item';
@Component({
  selector: 'app-test-barcode',
  templateUrl: './test-barcode.component.html',
  styleUrl: './test-barcode.component.scss',
})
export class TestBarcodeComponent implements OnInit {
  scannedBarcodes: string[] = [];
  lots: LotItem[] = [];

  constructor(
    private barcodeService: BarcodeScannerService,
    private readonly inventoryLotProxyService: LotItemProxyService,
  ) {}

  ngOnInit() {
    this.barcodeService.barcode$.subscribe((barcode) => {
      this.scannedBarcodes.push(barcode);
      this.getInventoryLot(barcode);
    });
  }

  getInventoryLot(lotId: string) {
    this.inventoryLotProxyService.getInventoryLotByLotId(lotId).subscribe({
      next: (response) => {
        const inventoryLot = response.data;
        if (inventoryLot) {
          this.lots.push(inventoryLot);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
}
